import React, { useState } from "react";

import InfoBox from "./InfoBox";

import "./AppBox.css";

export default function AppBox() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState("");
  const [error, setError] = useState(false);

  const handleClick = () => {
    if (search !== "") {
      async function fetchAPI() {
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=c06d611c16288832acbcff5d52c668e5&units=metric`
        );
        const datares = await response.json();
        console.log(datares);
        setData(datares);
        if (datares.cod === "404") {
          setError(true);
          alert("PLEASE ENTER VALID CITY NAME!!!");
        } else {
          setError(false);
        }
      }
      fetchAPI();
      console.log(data);
    }
  };

  return (
    <div>
      <div className="container">
        <div className="box">
          <div className="input-box">
            <input
              type="search"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleClick();
                }
              }}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <button onClick={handleClick}>
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
          </div>

          {!data || error ? (
            <h1 className="error-heading">Enter The City Name</h1>
          ) : (
            <>
              {" "}
              <InfoBox
                temperature={data.main.temp}
                cityName={data.name}
                countryName={data.sys.country}
                humidity={data.main.humidity}
                windSpeed={data.wind.speed}
                visibility={data.visibility}
                description={data.weather[0].main}
              />{" "}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
